module.exports = __webpack_public_path__ + "img/05_cookbook_(white).ef4d0d18.svg";